<template>
<div class="rider">
  <HeaderTab @tabIndexReceive="getTabIndex"></HeaderTab>
  <div class="rider_wrapper">
		<!-- 信息录入 -->
		<div class="infoInput">
			<!-- 操作 -->
			<div class="wrapper-oper" v-show="tabIndex == 0">
				<div class="oper-left">
					<span class="button upLoad" @click="riderUpLoad"><img src="../assets/upload.png" >数据上传</span>
					<span class="button" @click="downloadtpl"><img src="../assets/updown.png">下载模版</span>
					<span class="button" :class="{batchDelete: deleteList.length <= 0}" @click="batchDelete"><img src="../assets/delete.png">删除</span>
				</div>
				<div class="oper-right">
					<span class="button" @click="inputData">录入骑手资源库</span>
				</div>
			</div>
			<!-- 提示 -->
			<!-- <div class="tipsWrapper" v-show="tabIndex == 0">
				<div class="tips-left">
					<img src="../assets/tips.png" >
					<span>数据导入成功<em>200</em>条，失败<em>100</em>条，失败原因：身份证号重复</span>
				</div>
				<el-button type="text">下载失败数据</el-button>
			</div> -->
			<el-form v-show="tabIndex == 1" :inline="true" :model="riderSearch" ref="riderSearchRefs" class="demo-form-inline">
				<el-form-item label="城市：" prop="cityName">
					<el-select clearable v-model="riderSearch.cityName" filterable placeholder="城市">
						<el-option
							v-for="(item, index) in cityList"
							:key="index"
							:value="item"
							:label="item"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="站点：" prop="siteName">
					<el-select clearable v-model="riderSearch.siteName" filterable placeholder="站点">
						<el-option
							v-for="(item, index) in siteList"
							:key="index"
							:value="item"
							:label="item"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="姓名："  prop="name">
						<el-input v-model="riderSearch.name" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item label="入职日期：">
					<el-date-picker
						clearable
						v-model="enterTime"
						type="monthrange"
						format="yyyy-MM"
						value-format="yyyy-MM"
						range-separator="至"
						start-placeholder="开始月份"
						end-placeholder="结束月份">
					</el-date-picker>
					<!-- <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="riderSearch.ruZhiDate" style="width: 100%;"></el-date-picker> -->
				</el-form-item>
				<el-form-item label="离职日期：">
					<el-date-picker
						clearable
						v-model="leaveTime"
						type="monthrange"
						format="yyyy-MM"
						value-format="yyyy-MM"
						range-separator="至"
						start-placeholder="开始月份"
						end-placeholder="结束月份">
					</el-date-picker>
					<!-- <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="riderSearch.liZhiDate" style="width: 100%;"></el-date-picker> -->
				</el-form-item>
				<el-form-item label="骑手ID：" prop="idNum">
					<el-input type="text" v-model="riderSearch.idNum" placeholder="骑手ID"></el-input>
				</el-form-item>
				<el-form-item label="电话号码：" prop="phone">
					<el-input type="text" v-model="riderSearch.phone" placeholder="电话号码"></el-input>
				</el-form-item>
				<el-form-item label="身份证号码：" prop="idCard">
					<el-input type="text" v-model="riderSearch.idCard" placeholder="身份证号码"></el-input>
				</el-form-item>
				<el-form-item label="骑手类型：" prop="qsType">
					<el-select clearable filterable v-model="riderSearch.qsType" placeholder="骑手类型">
						<el-option
							v-for="(item, index) in riderTypeList"
							:key="index"
							:value="item"
							:label="item"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="外卖平台：" prop="wpPlatform">
					<el-select clearable filterable v-model="riderSearch.wpPlatform" placeholder="外卖平台">
						<el-option
							v-for="(item, index) in wpPlatformList"
							:key="index"
							:value="item"
							:label="item"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="formSearch">搜索</el-button>
					<el-button @click="formReset">重置</el-button>
				</el-form-item>
			</el-form>
			<!-- 表格 -->
			<div class="tableWrapper">
				<el-table
					:data="tableData"
					ref="tableDataRefs"
					stripe
					height="calc(100vh - 325px)"
					style="width: 100%"
					:key="keyValue"
					@selection-change="handleSelectionChange">
					<el-table-column
						type="index"
						label="#"
						width="50"
						align="left"
					></el-table-column>
					<el-table-column
						v-if="tabIndex == 0"
						type="selection"
						width="55" />
					<el-table-column
						prop="cityName"
						label="城市"
						width="140">
					</el-table-column>
					<el-table-column
						prop="siteName"
						label="站点"
						width="220">
					</el-table-column>
					<el-table-column
						prop="name"
						label="姓名"
						width="140">
					</el-table-column>
					<el-table-column
						prop="idNum"
						label="骑手ID"
						sortable
						:sort-method="(a, b) => { return a.idNum - b.idNum }"
						width="140">
					</el-table-column>
					<el-table-column
						prop="phone"
						label="电话号码">
					</el-table-column>
					<el-table-column
						prop="idCard"
						label="身份证号码"
						width="200">
					</el-table-column>
					<el-table-column
						sortable
						prop="ruZhiDate"
						label="入职日期">
					</el-table-column>
					<el-table-column
						prop="liZhiDate"
						label="离职日期"
						sortable>
					</el-table-column>
					<el-table-column
						prop="qsType"
						label="骑手类型">
					</el-table-column>
					<el-table-column
						prop="wpPlatform"
						label="外卖平台">
					</el-table-column>
					<el-table-column
						label="操作"
						width="100">
						<template slot-scope="scope">
							<img class="onlyDelete" src="../assets/delete.png" @click="onlyDelete(scope.row.id)">
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<span>共 {{ paginationData.total }} 条数据</span>
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="paginationData.current"
						:page-sizes="[10, 50, 100, 150, 200]"
						:page-size="paginationData.size"
						layout="prev, pager, next, sizes, jumper"
						:total="paginationData.total">
					</el-pagination>
				</div>
			</div>
		</div>
  </div>
	<!-- 无数据页面 -->
	<!-- <div class="enpty" v-if="(tabIndex == 0 && tableData) || (tabIndex == 1 && tableData.length <= 0)">
		<img src="../assets/empty.png" >
		<span>暂无数据</span>
	</div> -->
	<el-upload
		v-show="false"
		ref="itemUpload"
		class="upload-demo"
		action="#"
		:before-upload="beforeAvatarUpload"
		accept=".xls, .exls, .xlsx,"
		:http-request="beforeRiderUpload"
		:show-file-list="false"
		multiple
	>
		<el-button id="rinderUpLoadButton">选取文件</el-button>
	</el-upload>
	<el-dialog
		title="提示"
		:visible.sync="dialogVisible"
		width="30%">
		<div class="inputWrapper">
			<i class="el-icon-warning" style="color: #E6A23C;"></i><span>与骑手资源库身份证号相同的骑手信息，是否录入骑手资源库并覆盖更新 ？</span>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="noInputData">不录入</el-button>
			<el-button type="primary" @click="yesInputData">覆盖更新</el-button>
		</span>
	</el-dialog>
</div>
</template>

<script>
import HeaderTab from '../components/HeaderTab'
import { blobToObj, exportBillingExcel } from '../utils/common.js'
import { qsInfoPage, selectCity, selectSite, wpPlatform, selectQsType, qsResourcesPage, uploadQsInfo, qsInfoDel, y2Resources, no2Resources, qsZykInfoDel } from '../api/riderApi.js'
import local from '../utils/local.js'
export default {
  name: 'Rider',
  components:{
    HeaderTab
  },
  data() {
    return {
			dialogVisible: false,
			tableData: [],
			tabIndex: 0,
			keyValue: '',
			currentPage: 1,
      riderSearch:{
				cityName: '',
				siteName: '',
				name: '',
				ruZhiDate: '',
				liZhiDate: '',
				idNum: '',
				phone: '',
				idCard: '',
				qsType: '',
				wpPlatform: ''
      },
			enterTime: [],
			leaveTime: [],
			cityList: [],
			siteList:[],
			riderTypeList: [],
			deleteList: [],
			wpPlatformList: [],
			// current=1&size=10
			paginationData: {
				current: 1,
				size: 10,
				total: 0
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < new Date('2019-01') || time.getTime() > new Date() 
				},
			},
    }
  },
	mounted() {
		this.riderInfo()
	},
  methods: {
		// tab切换
		getTabIndex(index) {
			this.paginationData.current = 1
			this.tableData = []
			this.keyValue = Math.random();
			this.tabIndex = index
			if(index) {
				this.searchRander()
				this.riderResources()
			} else {
				this.riderInfo()
			}
		},
		// 检索列表
		searchRander(){
			selectCity().then(res => {
				if(res.code == 200) {
					this.cityList = res.data
				}
			})
			selectSite().then(res => {
				if(res.code == 200) {
					this.siteList = res.data
				}
			})
			selectQsType().then(res => {
				if(res.code == 200) {
					this.riderTypeList = res.data
				}
			})
			wpPlatform().then(res => {
				if(res.code == 200) {
					this.wpPlatformList = res.data
				}
			})
			
		},
		// 骑手录入信息列表
		riderInfo(){
			qsInfoPage(this.paginationData).then(res => {
				if(res.code == 200) {
					this.tableData = res.data.list
					this.paginationData.total = res.data.total
				}
			})
		},
		// 骑手资源列表
		riderResources(){
			let params = {...this.paginationData, ...this.riderSearch}
			qsResourcesPage(params).then(res => {
				if(res.code == 200) {
					this.tableData = res.data.list
					this.paginationData.total = res.data.total
				}
			})
		},
		handleSizeChange(val){
			this.paginationData.size = val
			this.paginationData.current = 1
			if(this.tabIndex) {
				this.riderResources()
			} else {
				this.riderInfo()
			}
		},
		handleCurrentChange(val){
			this.paginationData.current = val
			if(this.tabIndex) {
				this.riderResources()
			} else {
				this.riderInfo()
			}
		},
		// 重置
		formReset(){
			this.$refs['riderSearchRefs'].resetFields();
			this.enterTime = []
			this.leaveTime = []
			this.riderSearch.ruZhiDateStart = ''
			this.riderSearch.ruZhiDateEnd = ''
			this.riderSearch.liZhiDateStart = ''
			this.riderSearch.liZhiDateEnd = ''
			this.paginationData.current = 1
			this.riderResources()
		},
		// 搜索
		formSearch(){
			let time = {
				ruZhiDateStart: (this.enterTime && this.enterTime[0]) || '',
				ruZhiDateEnd: (this.enterTime && this.enterTime[1]) || '',
				liZhiDateStart: (this.leaveTime && this.leaveTime[0]) || '',
				liZhiDateEnd:  (this.leaveTime && this.leaveTime[1]) || ''
			}
			this.riderSearch = {...this.riderSearch, ...time}
			this.paginationData.current = 1
			this.riderResources()
		},
		// 单独删除
		onlyDelete(id){
			if(this.tabIndex) {
				let params = [id]
				this.qsZykdelete(params)
			} else {
				let params = [id]
				this.qsdelete(params)
			}
		},
		// 信息提交删除
		qsdelete(params) {
			this.$confirm('数据删除后将不能恢复', '是否删除选中数据 ？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				qsInfoDel(params).then(res => {
					if(res.code == 200) {
						this.$message.success("删除成功");
						this.riderInfo()
					}
				})
			}).catch(() => {});
		},

		// 骑手资源库删除
		qsZykdelete(params){
			console.log('骑手资源库删除')
			this.$confirm('数据删除后将不能恢复', '是否删除选中数据 ？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				qsZykInfoDel(params).then(res => {
					if(res.code == 200) {
						this.$message.success("删除成功");
						this.riderResources()
					}
				})
			}).catch(() => {});
		},
		
		// 批量删除
		batchDelete(){
			let len = this.deleteList.length
			if(len <= 0) {
				this.$message.error("无可操作数据");
			} else {
				let params = []
				this.deleteList.forEach(ele => {
					params.push(ele.id)
				})
				this.qsdelete(params)
			}
		},
		// 选择
		handleSelectionChange(val){
			this.deleteList = val
		},
		// 模板下载
		downloadtpl(){
			window.location.href = this.$Url + "/jundaWebSite/qsInfo/downloadtpl";
		},
		// 数据上传按钮
		riderUpLoad(){
			const button = document.getElementById("rinderUpLoadButton");
			button.click();
		},
		// 数据上传事件
		beforeRiderUpload(item) {
			let form = new FormData();
			form.append("file", item.file);
			uploadQsInfo(form).then(res => {
				if(res.size == 0) {
					this.$message.success("导入成功");
				} else {
					blobToObj(res).then(info => {
						if(info.code == 2111) {
							local.remove('userInfo')
							this.$message.warning(info.msg)
							this.$router.push('/login')
						} else {
							exportBillingExcel(res, {
								downLoadName: '骑手信息-批量添加数据-错误数据.xlsx',
							})
						}
					})
				}
				this.riderInfo()
			})
		},
		// 限制上传文件大小
		beforeAvatarUpload(file){
			const isLt2M = file.size / 1024 / 1024 < 50;
			if (!isLt2M) {
				this.$message.error('上传文件大小不能超过 50MB!');
			}
			return isLt2M;
		},
		// 数据录入
		inputData(){
			if(!this.tableData.length){
				this.$message.error("无可操作数据");
				return false
			}
			this.dialogVisible = true
		},
		// 不录入
		noInputData(){
			this.$confirm('录入后骑手数据不可更改删除。', '是否确定全部数据录入骑手资源库？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				no2Resources().then(res => {
					if(res.code == 200) {
						this.dialogVisible = false
						this.$message.success("录入成功");
						this.riderInfo()
					}
				})
			}).catch(() => {});
		},
		// 覆盖更新
		yesInputData(){
			this.$confirm('录入后骑手数据不可更改删除。', '是否确定全部数据录入骑手资源库？', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				y2Resources().then(res => {
					if(res.code == 200) {
						this.dialogVisible = false
						this.$message.success("录入成功");
						this.riderInfo()
					}
				})
			}).catch(() => {});
		}
  }
}
</script>

<style>
.rider_wrapper {
  width: 100%;
  box-sizing: border-box;
  padding: 22px 94px 0;
}
.wrapper-oper {
	width: 100%;
	height: 60px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 0 18px;
}
.pagination {
	height: 60px;
	align-items: center;
	display: flex;
	justify-content: space-between;
}
.oper-left,
.oper-right {
	display: flex;
}
.oper-left .button {
	margin-right: 16px;
}
.button {
	height: 40px;
	width: auto;
	box-sizing: border-box;
	padding: 0 22px;
	line-height: 40px;
	font-size: 16px;
	border: 1px solid #182C80;
	color: #182C80;
	border-radius: 3px;
	cursor: pointer;
	display: flex;
	align-items: center;
}
.button img {
	width: 16px;
	height: 16px;
	margin-right: 6px;
}
.button.upLoad {
	background: #182C80;
	color: #FFFFFF;
}
.button.batchDelete {
	border: 1px solid #9E9E9E;
	color: #9E9E9E;
}
.riderInfo {
	box-sizing: border-box;
	padding-top: 20px;
}
.enpty img {
	display: block;
	width: 543px;
	height: 254px;
	margin: 200px auto 40px;
}
.enpty span {
	display: block;
	font-size: 20px;
	color: #9E9E9E;
	text-align: center;
}
.onlyDelete {
	width: 40px;
	height: 40px;
	cursor: pointer;
}
/* .tipsWrapper {
	height: 37px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 1px solid #A8B5E6;
	background: #F3F6FF;
	box-sizing: border-box;
	padding: 0 10px;
	margin-bottom: 14px;
}
.tipsWrapper img {
	width: 16px;
	height: 16px;
	margin-right: 8px;
}
.tips-left {
	display: flex;
	align-items: center;
	font-size: 16xp;
	color: #6C7392;
}
.tips-left em {
	color: #D63B3B;
	padding: 0 4px;
	font-style: normal;
} */
.inputWrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}
.inputWrapper i {
	display: block;
	font-size: 22px;
	margin-right: 6px;
}
.inputWrapper span {
	width: 70%;
	font-size: 14px;
	line-height: 22px;
	margin-left: 4px;
	color: #303133;
}
.el-month-table td.end-date .cell, .el-month-table td.start-date .cell {
	background-color: #182C80;
	color: #FFFFFF;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #182C80;
}
.el-month-table td.today .cell,
.el-select-dropdown__item.selected {
	color: #182C80;
}
.el-select .el-input__inner:focus,
.el-range-editor.is-active, .el-range-editor.is-active:hover,
.el-input.is-active .el-input__inner, .el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #182C80;
}
.el-button--primary {
	background-color: #182C80!important;
	border-color: #182C80!important;
	color: #FFFFFF!important;
}
.el-button--default.el-button:focus, .el-button--default.el-button:hover {
	color: #182C80;
	border-color: #182C80;
	background-color: #fff;
}
.el-pagination__sizes .el-input .el-input__inner:hover,
.el-checkbox__inner:hover{
	border-color: #182C80;
}
.infoInput >>> .el-input.is-active .el-input__inner, 
.infoInput >>> .el-input__inner:focus {
    border-color: #182C80;
    outline: 0;
}
.rider ~ .el-select-dropdown .el-select-dropdown__item.selected {
    color: #182C80;
}
.el-table .ascending .sort-caret.ascending{
	border-bottom-color: #182C80;
}
.el-table .descending .sort-caret.descending{
	border-top-color: #182C80;
}

.tableWrapper ::-webkit-scrollbar {
  width: 15px;
  background-color: #fff;
}
.tableWrapper ::-webkit-scrollbar-thumb {
  width: 15px;
  border-radius: 2px;
  background-color: #e9eaee;
}
.el-loading-spinner i {
	color: #182C80;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
	border-color: #182C80;
	background-color: #182C80;
}
</style>
